import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BatchDeclineItem } from '../model/batch-decline';

/**
 * The itemized product list shown by Decline All and by its result dialog, so
 * the confirmation and the outcome name each product the same way.
 */
@Component({
  selector: 'app-decline-item-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './decline-item-list.component.html',
  styleUrl: './decline-item-list.component.scss',
})
export class DeclineItemListComponent {
  @Input() items: readonly BatchDeclineItem[] = [];
  @Input() listTestId = '';
  /**
   * Accessible name for the scrolling list. The list caps at four rows and
   * scrolls, and a scroll container holding no focusable element is not
   * reachable by keyboard in every browser, so it is a tab stop and needs a
   * name of its own.
   */
  @Input() listLabel = 'Products';
  @Input() itemTestId = '';
}
